import axios, { type AxiosError, type AxiosRequestConfig } from "axios";
import { config as apiConfig } from "../config";

export const api = axios.create({
  baseURL: apiConfig.api.url,
  headers: {
    common: {
      accept: "application/json",
      "content-type": "application/json",
    },
  },
  withCredentials: true,
  xsrfCookieName: apiConfig.csrfTokenCookieName,
  xsrfHeaderName: "x-csrf-token",
});

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const promise = api({
    ...config,
    ...options,
  }).then(({ data }) => data);

  return promise;
};

// // In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;

// export type BodyType<BodyData> = BodyData;

// // Or, in case you want to wrap the body type (optional)
// // (if the custom instance is processing data before sending it, like changing the case for example)
// export type BodyType<BodyData> = CamelCase<BodyData>;
